import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import style from '../cssmodules/section.module.scss';

function Section({ children, modifyer }) {
  return (
    <div className={classnames(style.section, style[modifyer])}>{children}</div>
  );
}

Section.defaultProps = {
  modifyer: false,
};

Section.propTypes = {
  children: PropTypes.element.isRequired,
  modifyer: PropTypes.string,
};

export default Section;
